import reducer from "./reducer";
export { default as KpiIndicators } from "./components/index";
export { default as kpiIndicatorsReducerName } from "./constants";
export default reducer;
